import { useCallback, useEffect, useMemo } from "react";
import { withStyles } from "@mui/styles";
import TextField from "@mui/material/TextField";
import find from "lodash/find";
import Autocomplete from "@mui/material/Autocomplete";
import { validate } from "../../utils/common";
import CategorySuggest from "./CategorySuggest";
import { sortProjectProps } from "../utils";
import useFilteredCategories from "../hooks/useFilteredCategories";
import PropTypes from "prop-types";
import { NO_PROJECT_ASSET } from "../../Components/Ava2/consts";
const renderTextbox = (props) => {
  const { classes } = props;
  return (
    <TextField
      variant="outlined"
      label="Resource"
      size="medium"
      helperText={props.helperText || " "}
      onChange={props.changeCategoryInfo}
      value={typeof props.categoryInfo !== "object" ? props.categoryInfo || "" : ""}
      className={classes.textField}
      fullWidth
      error={props.error ? (props.category ? validate(props.category.categoryInfo) : true) : false}
      required
      slotProps={{
        input: {
          className: classes.textFieldInput,
        },

        inputLabel: {
          shrink: true,
        },
      }}
    />
  );
};
const styles = () => ({
  textField: {
    marginTop: 30,
  },
});
const SelectCategory = (props) => {
  const filteredCategories = useFilteredCategories(props.categories);

  const { handleChangeCategory, changeCategoryInfo } = props;
  const isPlatformSelected = props.selectedPlatform && props.selectedPlatform.details.asset;

  let categoryList = sortProjectProps(props.platforms, props.categoryInfoList);

  const categoryListOptions = useMemo(
    () =>
      categoryList?.filter((category) => {
        const regex = /doitintl-fs/g;
        return category?.identifier?.match(regex) ? false : category;
      }),
    [categoryList]
  );

  const allCategories = useMemo(
    () => (props.noProjectAsset ? [NO_PROJECT_ASSET, ...categoryListOptions] : [...categoryListOptions]),
    [categoryListOptions, props.noProjectAsset]
  );

  let categoryInfo = "";

  if (isPlatformSelected) {
    categoryList = allCategories.filter(
      (cat) => cat.asset.replace("-standalone", "") === props.selectedPlatform.details.asset
    );
    categoryInfo = allCategories.find((c) => (c.accountId || c.identifier) === props.categoryInfo)?.identifier ?? "";
  } else {
    categoryList = [];
  }

  useEffect(() => {
    if (props.selectedPlatform?.resourceDisabled && props.categoryInfo !== "") {
      changeCategoryInfo("");
    }
  }, [changeCategoryInfo, props.categoryInfo, props.selectedPlatform]);

  return (
    <div>
      {props.step !== 2 && (
        <CategorySuggest
          categories={filteredCategories}
          categoryTitle={props.category?.name ?? props.category?.product}
          onChange={handleChangeCategory}
          error={props.error ? (props.category ? validate(props.category.title) : true) : false}
        />
      )}
      {!props.selectedPlatform?.resourceDisabled && props.step === 2 && (
        <>
          {categoryList.length > 0
            ? isPlatformSelected && (
                <>
                  <Autocomplete
                    id="combo-box-demo"
                    options={allCategories}
                    getOptionLabel={(option) => option.label || option.identifier || ""}
                    fullWidth
                    size="medium"
                    sx={{ mt: 2, mb: 2 }}
                    onChange={(event, newValue) => {
                      props.changeCategoryInfo(newValue);
                    }}
                    value={find(allCategories, { identifier: categoryInfo }) || null}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="medium"
                        helperText={props.helperText}
                        label={props.selectedPlatform?.label}
                        required
                        variant="outlined"
                        error={
                          props.error ? (props.category ? validate(props.category.categoryInfo) : true) : undefined
                        }
                        slotProps={{
                          inputLabel: {
                            shrink: true,
                          },
                        }}
                      />
                    )}
                  />
                </>
              )
            : renderTextbox(props)}
        </>
      )}
    </div>
  );
};

SelectCategory.propTypes = {
  categories: PropTypes.array,
  category: PropTypes.shape({
    name: PropTypes.string,
    product: PropTypes.string,
  }),
  categoryInfoList: PropTypes.array,
  helperText: PropTypes.string,
  handleChangeCategory: PropTypes.func,
  changeCategoryInfo: PropTypes.func,
  categoryInfo: PropTypes.string,
  selectedPlatform: PropTypes.object,
  platforms: PropTypes.array,
  error: PropTypes.bool,
};

export default withStyles(styles)(SelectCategory);
